import axios from 'axios'
import { event } from 'jquery'
import { localserver, commonBaseUrl } from './common'
// const localserver = 'https://events.webhook.biz'
// const mainserver = 'https://events.webhook.biz'
let token = localStorage.getItem('access_token') || ''

const EventID = localStorage.getItem('eventId') || ''
const eventParam = { event_id: EventID }
export const InsertForm = async (formDataObjects) => {
  localStorage.getItem('eventId')

  try {
    const formData = new FormData()
    formData.append('form_id', formDataObjects.id)
    formData.append('title', formDataObjects.title)
    formData.append('description', formDataObjects.description)
    formData.append('fileds', JSON.stringify(formDataObjects.fields))

    const res = await axios.post(`${localserver}/api/form_builder`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
      },
    })

    return res.data
  } catch (error) {
    console.error('Error inserting form:', error)
  }
}

export const getForm = async (id) => {
  const formData = new FormData()
  formData.append('id', {})
  try {
    const res = await axios.post(
      `${localserver}/api/get_form_data`,
      {},
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
        },
      }
    )
    return res.data
  } catch (error) {
    console.error('Error fetching form:', error)
    return null
  }
}

//
export const EditForm = async (formDataObjects) => {
  try {
    const formData = new FormData()

    // Append both IDs if available
    if (formDataObjects.form_id) {
      formData.append('form_id', formDataObjects.form_id)
    } else {
      formData.append('form_id', formDataObjects.id)
    }

    if (formDataObjects.id) {
      formData.append('id', formDataObjects.id)
    }
    formData.append('title', formDataObjects.title)
    formData.append('description', formDataObjects.description)
    formData.append('fileds', JSON.stringify(formDataObjects.fields))

    for (const pair of formData.entries()) {
    }

    const res = await axios.post(
      `${localserver}/api/form_builder_edit`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
        },
      }
    )

    return res.data
  } catch (error) {
    console.error('Error editing form:', error)
    return { status: false, error: error.message }
  }
}

export const GetTicketData = async () => {
  try {
    const res = await axios.get(`${localserver}/get_ticket_by_user`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    return res.data.tickets
  } catch (error) {
    console.error('Error fetching ticket data:', error)
    return null
  }
}

export const GetAllCouponsData = async (eventparams) => {
  try {
    const res = await axios.post(
      `${localserver}/all_coupons_by_user`,
      eventParam,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )

    return res.data.coupons
  } catch (err) {}
}
export const GetTicketsByID = async (data) => {
  console.log(data)
  try {
    const res = await axios.post(
      `${localserver}/get_ticket_by_event_id`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )

    return res
  } catch (err) {}
}
export const InsertEventTicket = async (formData) => {
  try {
    console.log('Sending request to API with data:', formData) // Log before the request to confirm function is called

    const res = await axios.post(
      `${localserver}/create_ticket_latest`,
      formData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )

    console.log(res.data, 'insert response')
    return res.data
  } catch (err) {
    console.error('Error in InsertEventTicket:', {
      error: err,
      responseData: err.response?.data,
      message: err.message,
      status: err.response?.status,
    })
    throw err
  }
}
const formatDateForMySQL = (dateStr) => {
  if (!dateStr) return null
  const date = new Date(dateStr)
  const yyyy = date.getFullYear()
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  const hh = String(date.getHours()).padStart(2, '0')
  const mi = String(date.getMinutes()).padStart(2, '0')
  const ss = String(date.getSeconds()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`
}
export const UpdateEventTickets = async (formData) => {
  try {
    // or wherever you're getting the token

    // Clone the formData to avoid mutating original
    const payload = { ...formData }

    // Format top-level dates
    payload.start_sale = formatDateForMySQL(formData.start_sale)
    payload.end_sale = formatDateForMySQL(formData.end_sale)
    payload.schedule_sale = formatDateForMySQL(formData.schedule_sale)
    payload.created_at = formatDateForMySQL(formData.created_at)

    // Format variable_prices dates
    if (Array.isArray(formData.variable_prices)) {
      payload.variable_prices = formData.variable_prices.map((vp) => ({
        ...vp,
        valid_till: formatDateForMySQL(vp.valid_till),
      }))
    }

    // Format addons dates
    if (Array.isArray(formData.addons)) {
      payload.addons = formData.addons.map((addon) => ({
        ...addon,
        created_at: formatDateForMySQL(addon.created_at),
      }))
    }

    // Guest details — nested formatting
    if (formData.guest_details) {
      payload.guest_details = {
        ...formData.guest_details,
        start_sale: formatDateForMySQL(formData.guest_details.start_sale),
        end_sale: formatDateForMySQL(formData.guest_details.end_sale),
        schedule_sale: formatDateForMySQL(formData.guest_details.schedule_sale),
        variable_prices: (formData.guest_details.variable_prices || []).map(
          (vp) => ({
            ...vp,
            valid_till: formatDateForMySQL(vp.valid_till),
          })
        ),
        addons: (formData.guest_details.addons || []).map((addon) => ({
          ...addon,
          created_at: formatDateForMySQL(addon.created_at),
        })),
      }
    }

    const res = await axios.post(`${localserver}/update_ticket_new`, payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })

    return res.data
  } catch (err) {}
}
export const UpdateCouponsData = async (formData) => {
  try {
    const res = await axios.post(`${localserver}/update_coupon`, formData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    return res.data
  } catch (err) {}
}
export const GetAddons = async (addon_status = 'onsale') => {
  try {
    const res = await axios.post(
      `${localserver}/get_addons`,
      {
        event_id: EventID,
        addon_status: addon_status,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )

    return res
  } catch (err) {}
}

export const InsertCoupons = async (formData) => {
  try {
    const res = await axios.post(`${localserver}/create_coupon`, formData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })

    return res.data
  } catch (err) {
    // Check if the error is a 409 Conflict (coupon code already exists)
    if (err.response && err.response.status === 409) {
      return {
        success: false,
        message: 'Coupon code already exists for this event',
      }
    }

    // For other errors, return a generic error response
    return {
      success: false,
      message: err.response?.data?.message || 'Failed to create coupon',
    }
  }
}
export const CreateFormes = async (formData) => {
  try {
    const res = await axios.post(`${localserver}/create_forms`, formData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })

    return res
  } catch (err) {
    throw err
  }
}
export const GetFormes = async (data) => {
  try {
    const res = await axios.post(
      `${localserver}/get_forms_by_event_id`,
      { event_id: data.event_id || EventID, status: data.status || 'active' },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return res
  } catch (err) {
    throw err
  }
}
export const UpdateFormes = async (formData) => {
  try {
    const res = await axios.post(`${localserver}/update_forms`, formData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    return res
  } catch (err) {
    throw err
  }
}
export const GetTaxSettings = async (eventId) => {
  try {
    const res = await axios.post(
      `${localserver}/getSettings`,
      {
        event_id: eventId,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )

    return res.data
  } catch (err) {
    throw err
  }
}
export const CreateAndUpdateTaxSettings = async (payload) => {
  try {
    const res = await axios.post(
      `${localserver}/create_update_event_settings`,
      {
        ...payload,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return res.data
  } catch (err) {
    console.error(err, 'error in create and update tax settings')
    throw err
  }
}

export const uploadFilesAWS = async (formData) => {
  try {
    const res = await axios.post(`${localserver}/upload_files`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    })
    return res
  } catch (err) {
    throw err
  }
}
export const UpdateguestTicketStatus = async (guestId, status) => {
  try {
    const res = await axios.post(
      `${localserver}/updateguest_ticket_status`,
      {
        guest_id: guestId,
        status: status,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return res.data
  } catch (err) {
    console.error(err, 'error in updating guest status')
    throw err
  }
}
export const GetEventRegistration = async (eventSlug, Token) => {
  const TokenPayload = Token ? `/${Token}` : '' // only append if token exists
  const registrationUrl = `${localserver}/events/registration/${eventSlug}`

  try {
    const res = await axios.post(
      `${localserver}/event_details`,
      {
        registration_url: registrationUrl,
        private_slug: Token || '',
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`, // make sure `token` is defined properly
        },
      }
    )

    return res.data
  } catch (err) {
    console.error(err)
    throw err
  }
}

export const EventRegister = async (formData) => {
  try {
    const res = await axios.post(`${localserver}/event_register`, formData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })

    return res.data
  } catch (err) {
    console.err(err)
    throw err
  }
}
export const EventRegisterPay = async (formData) => {
  try {
    const res = await axios.post(
      `${localserver}/event_create_payment`,
      formData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )

    return res.data
  } catch (err) {
    console.err(err)
    throw err
  }
}
export const VerifyAndCapture = async (data) => {
  try {
    const res = await axios.post(`${localserver}/verify_and_capture`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })

    return res
  } catch (err) {
    throw err
  }
}
//
export const UpdatePaymentStatus = async (data) => {
  try {
    const res = await axios.post(`${localserver}/update_payment_status`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })

    return res
  } catch (err) {
    throw err
  }
}
export const AttendeesUpdate = async (data) => {
  try {
    const res = await axios.post(`${localserver}/attendee_update`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })

    return res
  } catch (err) {
    throw err
  }
}
export const BuyerUpdate = async (data) => {
  try {
    const res = await axios.post(`${localserver}/buyer_update`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })

    return res
  } catch (err) {
    throw err
  }
}
//guest_update
export const GuestAtendeeUpdate = async (data) => {
  try {
    const res = await axios.post(`${localserver}/guest_update`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })

    return res
  } catch (err) {
    throw err
  }
}
export const GetBuyer = async (data) => {
  try {
    const res = await axios.post(
      `${localserver}/buyer_get`,
      { id: data },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )

    return res
  } catch (err) {
    throw err
  }
}
export const GetAttendee = async (data) => {
  try {
    const res = await axios.post(
      `${localserver}/attendee_get`,
      { id: data },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )

    return res
  } catch (err) {
    throw err
  }
}
export const MakeTicketPrivate = async (data) => {
  try {
    const res = await axios.post(`${localserver}/make_private`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })

    return res
  } catch (err) {
    throw err
  }
}
export const CouponValidation = async (data) => {
  try {
    const res = await axios.post(`${localserver}/coupen_validation`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })

    return res.data
  } catch (err) {
    throw err
  }
}
export const RefundStatusUpdate = async (data) => {
  try {
    const res = await axios.post(`${localserver}/RefundStatusUpdate`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    console.log(res)
    return res
  } catch (err) {
    console.log(err)
    throw err
  }
}
//commonBaseUrl
export const GetMemberDetails = async (member_no) => {
  try {
    const res = await axios.post(
      `${commonBaseUrl}/api/member_detail_data`,
      member_no,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )
    console.log(res)
    return res.data
  } catch (err) {
    console.log(err)
    throw err
  }
}
export const UpdateCustomeRegCode = async (payload) => {
  try {
    const res = await axios.post(
      `${localserver}/UpdateCustomeRegCode`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )
    console.log(res)
    return res.data
  } catch (err) {
    console.log(err)
    throw err
  }
}
//member_detail_data_test
// export const GetMemberAllDetails = async (member_no) => {
//   try {
//     const res = await axios.post(
//       `${commonBaseUrl}/api/member_detail_data`,
//       member_no,
//       {
//         headers: {
//           'Content-Type': 'application/json',
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     )
//     console.log(res)
//     return res.data
//   } catch (err) {
//     console.log(err)
//     throw err
//   }
// }
export const GetMemberAllDetails = async (member_no) => {
  console.log("member_no: ", member_no)
  try {
    const res = await axios.get(
      `${localserver}/getMemberInfo/${member_no}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )
    console.log(res)
    return res.data
  } catch (err) {
    console.log(err)
    throw err
  }
}
export const createBadge = async (payload) => {
  const updatedpayload = { ...payload, event_id: EventID }

  try {
    const response = await axios.post(
      `${localserver}/createBadge`, // change this to your real endpoint
      updatedpayload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )

    console.log('Badge saved successfully:', response.data)
    return response.data // { success: true, message: "...", data: {...} }
  } catch (err) {
    console.error('Error saving badge:', err)

    // Better error handling
    const errorMessage =
      err.response?.data?.message ||
      err.message ||
      'Failed to save badge template'

    throw new Error(errorMessage)
  }
}
export const GetBadgeList = async () => {
  try {
    const res = await axios.post(
      `${localserver}/listBadges`,
      { event_id: EventID },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )
    console.log(res)
    return res.data
  } catch (err) {
    console.log(err)
    throw err
  }
}
export const UpdateBadge = async (payload) => {
  const updatedpayload = { ...payload, event_id: EventID }
  try {
    const res = await axios.post(`${localserver}/updateBadge`, updatedpayload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    console.log(res)
    return res.data
  } catch (err) {
    console.log(err)
    throw err
  }
}
export const DeleteBadge = async (badgeID) => {
  try {
    const res = await axios.post(
      `${localserver}/deleteBadge`,
      { id: badgeID },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )
    console.log(res)
    return res.data
  } catch (err) {
    console.log(err)
    throw err
  }
}
export const createCertificate = async (payload) => {
  const updatedpayload = { ...payload, event_id: EventID }

  try {
    const response = await axios.post(
      `${localserver}/createCertificate`, // change this to your real endpoint
      updatedpayload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )

    console.log('Badge saved successfully:', response.data)
    return response.data // { success: true, message: "...", data: {...} }
  } catch (err) {
    console.error('Error saving badge:', err)

    // Better error handling
    const errorMessage =
      err.response?.data?.message ||
      err.message ||
      'Failed to save badge template'

    throw new Error(errorMessage)
  }
}
export const GetCertificateList = async () => {
  try {
    const res = await axios.post(
      `${localserver}/listCertificates`,
      { event_id: EventID },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )
    console.log(res)
    return res.data
  } catch (err) {
    console.log(err)
    throw err
  }
}
export const UpdateCertificate = async (payload) => {
  const updatedpayload = { ...payload, event_id: EventID }
  try {
    const res = await axios.post(`${localserver}/updateCertificate`, updatedpayload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    console.log(res)
    return res.data
  } catch (err) {
    console.log(err)
    throw err
  }
}
export const DeleteCertificate = async (certificateID) => {
  try {
    const res = await axios.post(
      `${localserver}/deleteCertificate`,
      { id: certificateID },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )
    console.log(res)
    return res.data
  } catch (err) {
    console.log(err)
    throw err
  }
}
export const GenarateBadge = async (payload) => {
  const updatedPayload ={...payload,event_id:EventID}
  try {
    const res = await axios.post(
      `${localserver}/generate_badge`,
      updatedPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )
    console.log(res)
    return res.data
  } catch (err) {
    console.log(err)
    throw err
  }
}
export const GenarateCertifacate = async (payload) => {
  const updatedPayload ={...payload,event_id:EventID}
  try {
    const res = await axios.post(
      `${localserver}/generate_certificate`,
      updatedPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )
    console.log(res)
    return res.data
  } catch (err) {
    console.log(err)
    throw err
  }
}
export const printBadge = async (payload) => {
  const updatedPayload ={...payload,event_id:EventID}
  try {
    const res = await axios.post(
      `${localserver}/print_badge`,
      updatedPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )
    console.log(res)
    return res.data
  } catch (err) {
    console.log(err)
    throw err
  }
}
export const printCertificate = async (payload) => {
  const updatedPayload ={...payload,event_id:EventID}
  try {
    const res = await axios.post(
      `${localserver}/print_certificate`,
      updatedPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )
    console.log(res)
    return res.data
  } catch (err) {
    console.log(err)
    throw err
  }
}
export const UserImport  = async (payload) => { 
  const updatedPayload ={...payload,event_id:EventID}
  try {
    const res = await axios.post(
      `${localserver}/uploadAttendeesCSV`,
      updatedPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )
    console.log(res)
    return res.data
  } catch (err) {
    console.log(err)
    throw err
  }
}
export const DownloadBadge = async (event_id, attendee_id) => {
  console.log(event_id, attendee_id, "event_id,attendee_id")
  try {
    const res = await axios.get(`${localserver}/downloadBadgePDF/${event_id}/${attendee_id}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    return res.data
  } catch(err) {
    console.log(err)
  }
}
export const DownloadCertificate =async (event_id,attendee_id)=>{
  try{
const res = await axios.get(`${localserver}/downloadCertificate/${event_id}/${attendee_id}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    return res.data
  }
  catch(err){
    console.log(err)
  }
}


